import React from 'react';
import service from "../../../service/service";
import DownloadReport from "../DownloadReport";

export default function UnusedEbsDownloadReport() {
    const apiCallFunction = service.monitoring().downloadEbs
    return <DownloadReport downloadFunction={apiCallFunction} title={'Download unused EBS report'}/>
}